<template>
  <div>
    <div id="search">
      <el-row style="margin-bottom: 20px">
      <el-col>
        旗帜：<el-select v-model="sellerFlag" size="mini" style="width: 100px; margin-right: 30px" placeholder="请选择">
        <el-option
          v-for="item in flagOpto"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

        <el-checkbox v-model="hasMemo" style="margin-right: 30px">有备注</el-checkbox>
        <el-button type="primary" size="small" @click="getWlbData">搜索</el-button><el-button type="primary"  size="small" @click="getWlbTb">同步三段码</el-button>
      </el-col>
    </el-row>
    </div>

    <el-row>
      <el-col :span="2">
        <el-button type="primary" size="mini" @click="hide" style="">全屏显示/恢复</el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-table border style="font-size: 12px" ref="multipleTable"
                  :data="wlbData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column  prop="shortAddress" label="集包地" width="100px"></el-table-column>
          <el-table-column  prop="waybillCode" label="单号"  width="120px"></el-table-column>


          <el-table-column  prop="consigneeName" label="收件人" width="80px"></el-table-column>
          <el-table-column  prop="trueReceiverMobile" label="手机" width="80px"></el-table-column>
          <el-table-column  prop="consigneeProvince" label="省" width="80px"></el-table-column>
          <el-table-column  prop="consigneeCity" label="市" width="80px"></el-table-column>
          <el-table-column  prop="consigneeArea" label="区县" width="80px"></el-table-column>
          <el-table-column  prop="consigneeAddress" label="地址" ></el-table-column>

          <el-table-column  prop="sendName" label="发件人" width="80px"></el-table-column>
          <el-table-column  prop="sendPhone" label="手机" width="80px"></el-table-column>
          <el-table-column  prop="sendProvince" label="省" width="80px"></el-table-column>
          <el-table-column  prop="sendCity" label="市" width="80px"></el-table-column>
          <el-table-column  prop="sendArea" label="区县" width="80px"></el-table-column>
          <el-table-column  prop="sendAddress" label="地址" ></el-table-column>


          <el-table-column  prop="title" label="物品" width="150px"></el-table-column>

          <el-table-column  prop="sellerNick" label="订购人" width="120px"></el-table-column>
        </el-table>

      </el-col>
    </el-row>

    <div id="page" class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[100, 500, 1000, 5000]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
    import storage from "../api/storage";
    import $api from "../api/axios";

    export default {
        name: "Wlb",
      data(){
          return{
            wlbData:[],
            display:1,
            hasMemo:false,
            sellerFlag:-1,
            funName:'GetWlb',
            flagOpto:[{value:-1,label:'全部'},{value:0,label:'0-灰色'},{value:1,label:'1-红色'},{value:2,label:'2-黄色'},{value:3,label:'3-绿色'},{value:4,label:'4-蓝色'},{value:5,label:'5-紫色'}],
            memoOpto:[{value: '>0', label: '有备注'},{value: '=0', label: '无备注'}],
            pageObject: {
              pageCurrent: 1,
              rowCount: 0,
              pageSize: 100
            },

        }
      },
      methods:{
        hide:function(){
          this.display++;
          if(this.display % 2 == 0){
            window.document.getElementById("left").style.display = 'none';
            window.document.getElementById("top").style.display = 'none';
            window.document.getElementById("search").style.display = 'none';
            window.document.getElementById("page").style.display = 'none';
          }else {
            window.document.getElementById("left").style.display = 'block';
            window.document.getElementById("top").style.display = 'block';
            window.document.getElementById("search").style.display = 'block';
            window.document.getElementById("page").style.display = 'block';
          }

        },
        getWlbData:function () {
          this.funName="GetTrades";
          this.cnName=" 三段码 ";
          let param={
            nick: storage.get("nick"),
            subNick:storage.get("subnick"),
            funName:this.funName,
            hasMemo: this.hasMemo,
            sellerFlag: this.sellerFlag,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
          }
          $api.post("/wlb/get", param, response =>{
            let dataResult =  response.data;
            console.log(dataResult);
            if(dataResult.state == 1 && dataResult.message == "ok"){
              this.wlbData = dataResult.data.wlb;

              let pageObject = dataResult.data.pageObject;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
              this.$message.success("获取订单数据成功！");
            }
            else{
              this.$message.error(dataResult.message);

            }
          })
        },
        getWlbTb:function () {
          let param={
            nick: storage.get("nick"),
            subNick:storage.get("subnick"),
            hasMemo: this.hasMemo,
            sellerFlag: this.sellerFlag,
            funName:"GetTrades",
          }
          $api.post("/wlb/wlbtb", param, response =>{
            let dataResult =  response.data;
            console.log(dataResult);
            if(dataResult.state == 1 && dataResult.message == "ok"){
              this.msg='数据同步中.....';
              this.timer = setTimeout(this.getStatus, 1000);
            }
            else{
              this.$message.error(dataResult.message);

            }
          })
        },
        //轮询同步状态
        getStatus:function () {
          console.log("get1.");
          this.msg='';
          let param={
            nick:storage.get("nick"),
            subNick:storage.get("subnick"),
            funName:this.funName,
            status:"1",
          }
          console.log(this.funName);
          $api.post("/trade/getStatus", param, response =>{
            let dataResult =  response.data;
            console.log(dataResult);
            if(dataResult.data == "success") {
              clearTimeout(this.timer);
              this.getWlbData();
              this.$message.success("【"+"三段码" +"】数据同步完成。");

            }
            else {
              this.timer = setTimeout(this.getStatus, 3000);
              this.msg='数据同步中.....';
              this.$message.warning("数据同步中.....");
            }
          })
        },

      },
      mounted(){
        this.getWlbData();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/Wlb.vue